import { emptyCSSTemplateFunc } from '@hzero-front-ui/core';
var selectBoxData = {
  name: 'selectBox',
  data: [],
  onlyTemplate: emptyCSSTemplateFunc
};
export default selectBoxData;